import { cloneDeep, random } from "lodash";

/**
 * Random looping sequence with no repeats
 * @Type T
 * @param input array of items of Type T, no dupes
 */
export class RandomSequence<T> {
    private sequence: T[];
    private length: number;
    private currentIndex = 0;

    constructor(private readonly input: T[]) {

        this.sequence = this.generate();
        this.length = input.length;
    }

    next(): T {
        if (this.currentIndex >= this.length) {

            this.sequence = this.generate(this.sequence[this.length - 1]);
            this.currentIndex = 0;
        }

        const next = this.sequence[this.currentIndex];
        this.currentIndex++;

        return next;
    }

    private generate(lastIndex?: T): T[] {

        const set = cloneDeep(this.input);

        const out = [];

        while (set.length > 0) {

            const index = random(0, set.length - 1);
            out.push(set.splice(index, 1)[0]);
        }

        //Ensure last of current and first of next do not match
        if (lastIndex !== undefined && lastIndex === out[0]) {

            const first = <T>out.shift();
            const newIndex = random(1, this.length - 1);
            out.splice(newIndex, 0, first);
        }

        return out;
    }
}